module.exports = __webpack_public_path__ + "static/img/23_qixiangzhan.0c17ae25.png";